module.exports = __webpack_public_path__ + "static/media/EP01@m.a758f74d.jpg";